import React, {useState} from 'react';
import profileImg from 'contents/assets/img/profile_default.png';
import Tab from '../../component/Inc/Tab';
import PopLeave from './_PopLeave';
import PopManageCompany from './_PopManageCompany';
import PopManagePosition from './_PopManagePosition';
import PopManageSalary from './_PopManageSalary';
import PopManageDepartment from './_PopManageDepartment';
import PopManageEmployee from './_PopManageEmployee';
function EmployeeInfo() {
  const [modalLeaveOpen, setModalLeaveOpen] = useState(false);
  const [modalManageCompany, setModalManageCompany] = useState(false);
  const [modalManageEmployee, setModalManageEmployee] = useState(true);
  const [modalManagePosition, setModalManagePosition] = useState(false);
  const [modalManageSalary, setModalManageSalary] = useState(false);
  const [modalManageDepartment, setModalManageDepartment] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '내근직원', value: 0},
    {title: '교사', value: 1},
    {title: '전략기획실', value: 2},
    {title: '홍보부', value: 3}
  ];
  return (
    <main className="com_container com_member_info">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu9_1">
            직원 관리 <span className="bar" />
            <span className="point_txt">최교사103</span>
          </h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalManageCompany(true)} className="com_btn orange s btn_settings">
              법인 관리
            </button>
            <button onClick={() => setModalManageDepartment(true)} className="com_btn orange s btn_settings">
              부서 관리
            </button>
            <button onClick={() => setModalManageEmployee(true)} className="com_btn orange s btn_plus">
              직원 등록
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
            <hr className="com_divider" />
            {tabIdx === 0 ? (
              <>
                {/* 프로필 */}
                <div className="info_top">
                  <div className="thumb">
                    <img src={profileImg} alt="프로필 이미지" />
                    <button className="btn_camera"></button>
                  </div>
                  <div className="com_input_wrap">
                    <div className="input_row">
                      <input type="text" className="input" placeholder="내근직원 이름" />
                      <select className="select">
                        <option value="법인 선택">법인 선택</option>
                      </select>
                      <div className="check">
                        <input type="radio" name="rdo1" id="rdo06" className="com_chk circle" />
                        <label htmlFor="rdo06">정규직</label>
                        <input type="radio" name="rdo1" id="rdo07" className="com_chk circle" />
                        <label htmlFor="rdo07">프리랜서 </label>
                        <input type="radio" name="rdo1" id="rdo05" className="com_chk circle" />
                        <label htmlFor="rdo05">계약직 </label>
                      </div>
                    </div>
                    <div className="input_row">
                      <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      <div className="check">
                        <input type="radio" name="rdo_sex" id="rdo03" className="com_chk circle" />
                        <label htmlFor="rdo03">남</label>
                        <input type="radio" name="rdo_sex" id="rdo04" className="com_chk circle" />
                        <label htmlFor="rdo04">여</label>
                      </div>
                      <button className="com_btn orange xs">재직</button>
                    </div>
                    <div className="input_row">
                      <ul className="part_list">
                        <li>
                          <div className="input_row">
                            <select className="select">
                              <option value="본사">본사</option>
                              <option value="지사">지사</option>
                            </select>
                            <select className="select">
                              <option value="전략기획실">전략기획실</option>
                              <option value="인사팀">인사팀</option>
                            </select>
                            <select className="select">
                              <option value="수시팀">수시팀</option>
                            </select>
                            <select className="select">
                              <option value="담당">담당</option>
                            </select>
                            <select className="select">
                              <option value="담당2">담당2</option>
                            </select>
                          </div>
                        </li>
                        <li>
                          <div className="input_row">
                            <select className="select">
                              <option value="전략기획실">전략기획실</option>
                              <option value="인사팀">인사팀</option>
                            </select>
                            <select className="select">
                              <option value="수시팀">수시팀</option>
                            </select>
                            <select className="select">
                              <option value="담당">담당</option>
                            </select>
                            <select className="select">
                              <option value="담당2">담당2</option>
                            </select>
                          </div>
                          <button className="btn_add_gray"></button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* 상세 */}
                <table className="com_board_list type_row">
                  <colgroup>
                    <col width="10%" />
                    <col width="35%" />
                    <col width="10%" />
                    <col width="35%" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>아이디</th>
                      <td className="type_row bold">ase234@naver.com </td>
                      <th>직급</th>
                      <td>
                        <div className="com_input_wrap flex_between">
                          부장 (2021, 05., 12 (부장 3년차))
                          <button onClick={() => setModalManagePosition(true)} className="com_btn gray xs">
                            직급변경
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>비밀번호</th>
                      <td className="type_row">!@#**2344</td>
                      <th>직책</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <select className="select wm">
                            <option value="직책">직책</option>
                            <option value="팀장">팀장</option>
                          </select>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>휴대폰</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="text" className="input" defaultValue={`010-2322-2222`} />
                        </div>
                      </td>
                      <th>연봉</th>
                      <td>
                        <div className="com_input_wrap flex_between">
                          <input type="password" className="input" defaultValue={`7000`} />
                          <button onClick={() => setModalManageSalary(true)} className="com_btn gray xs">
                            연봉보기
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>이메일</th>
                      <td>
                        <input type="text" className="input" />
                      </td>
                      <th>학력 / 전공</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="text" className="input" defaultValue={`한국방송통신대`} />
                          <input type="text" className="input" defaultValue={`미디어영상학과`} />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>생일</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                          <input type="checkbox" name="chkBirthday" id="chkBirthday" className="com_chk" />
                          <label htmlFor="chkBirthday">음력</label>
                        </div>
                      </td>
                      <th>계좌 정보</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <select className="select wm">
                            <option value="하나은행">하나은행</option>
                          </select>
                          <input type="text" className="input ws" defaultValue={`홍길동`} />
                          <input type="text" className="input wl" defaultValue={`828282918292`} />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>입사일</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                          <span className="txt">입사 12년차</span>
                        </div>
                      </td>
                      <th rowSpan={2}>경력</th>
                      <td rowSpan={2}>
                        <div className="txt">
                          **에듀에서 영어강사로 3년 근무
                          <br />
                          **에듀에서 영어강사로 3년 근무
                          <br />
                          **에듀에서 영어강사로 3년 근무
                          <br />
                          **에듀에서 영어강사로 3년 근무
                          <br />
                          **에듀에서 영어강사로 3년 근무
                          <br />
                          **에듀에서 영어강사로 3년 근무
                          <br />
                          **에듀에서 영어강사로 3년 근무
                          <br />
                          **에듀에서 영어강사로 3년 근무
                          <br />
                          **에듀에서 영어강사로 3년 근무
                          <br />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>보험</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="date" className="com_datepicker" placeholder="보헙가입일" />
                          <input type="date" className="com_datepicker" placeholder="보험유지일" />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>면접/소개/컨택자</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <select className="select wm">
                            <option value="면접자">면접자</option>
                          </select>
                          <select className="select wm">
                            <option value="소개자">소개자</option>
                          </select>
                          <select className="select wm">
                            <option value="컨택자">컨택자</option>
                          </select>
                        </div>
                      </td>
                      <th rowSpan={3}>메모</th>
                      <td rowSpan={3}>
                        <div className="txt_memo">
                          메모메모메모
                          <br />
                          메모메모메모
                          <br />
                          메모메모메모
                          <br />
                          메모메모메모
                          <br />
                          메모메모메모
                          <br />
                          메모메모메모
                          <br />
                          메모메모메모
                          <br />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>주소</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="text" className="input wl" placeholder="주소" />
                          <button className="com_btn gray xs">우편번호</button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>상세주소</th>
                      <td>
                        <input type="text" className="input" placeholder="주소" />
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div className="com_btn_wrap center bottom">
                  <button className="com_btn orange s">수정</button>
                  <button
                    onClick={() => {
                      setModalLeaveOpen(true);
                    }}
                    className="com_btn line gray s btn_enter"
                  >
                    회원 탈퇴
                  </button>
                </div>
              </>
            ) : tabIdx === 1 ? (
              <>
                {/* 프로필 */}
                <div className="info_top">
                  <div className="thumb">
                    <img src={profileImg} alt="프로필 이미지" />
                    <button className="btn_camera"></button>
                  </div>
                  <div className="com_input_wrap">
                    <div className="input_row">
                      <input type="text" className="input" placeholder="교사명" />
                      <div className="check">
                        <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                        <label htmlFor="rdo01">교사</label>
                        <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                        <label htmlFor="rdo02">담임</label>
                      </div>
                    </div>
                    <div className="input_row">
                      <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      <div className="check">
                        <input type="radio" name="rdo_sex" id="rdo03" className="com_chk circle" />
                        <label htmlFor="rdo03">남</label>
                        <input type="radio" name="rdo_sex" id="rdo04" className="com_chk circle" />
                        <label htmlFor="rdo04">여</label>
                      </div>
                    </div>
                    <div className="input_row">
                      <select className="select">
                        <option value="본사">본사</option>
                        <option value="지사">지사</option>
                      </select>
                      <select className="select">
                        <option value="고등부">고등부</option>
                        <option value="중등부">중등부</option>
                      </select>
                      <select className="select">
                        <option value="파트">파트</option>
                      </select>
                      <div className="check">
                        <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                        <label htmlFor="chk01">대면</label>
                        <input type="checkbox" name="chk" id="chk02" className="com_chk" />
                        <label htmlFor="chk02">화상</label>
                      </div>
                    </div>
                  </div>
                  <div className="btn_wrap">
                    <div className="wrap">
                      <button className="com_btn orange xs btn_mail_white">메일보내기</button>
                      <button className="com_btn orange xs btn_sms">문자 보내기</button>
                      <button className="com_btn red xs ">배정대기 : +468</button>
                    </div>
                    <div className="wrap">
                      <button className="com_btn black xs btn_plus_orange">면접 정보 보기</button>
                    </div>
                    <div className="wrap">
                      <span className="com_check_box">
                        <input type="checkbox" name="chk" id="chk010" className="com_chk" />
                        <label htmlFor="chk010">교사 레트카드</label>
                      </span>
                    </div>
                  </div>
                </div>

                {/* 상세 */}
                <table className="com_board_list type_row">
                  <colgroup>
                    <col width="10%" />
                    <col width="35%" />
                    <col width="10%" />
                    <col width="35%" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>아이디</th>
                      <td className="type_row bold">ase234@naver.com</td>
                      <th>영역 상세</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <select className="select">
                            <option value="영어">영어</option>
                            <option value="국어">국어</option>
                          </select>
                          <input type="text" className="input" defaultValue={`외국어영역`} />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>비밀번호</th>
                      <td className="type_row">!@#**2344</td>
                      <th>직급 / 상태</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <select className="select wm">
                            <option value="사원">사원</option>
                            <option value="대리">대리</option>
                          </select>
                          <select className="select wm">
                            <option value="호봉">호봉</option>
                          </select>
                          <select className="select wm">
                            <option value="B그룹">B그룹</option>
                          </select>
                          <select className="select wm">
                            <option value="내신A">내신A</option>
                          </select>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>휴대폰</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <select className="select">
                            <option value="교폰">교폰</option>
                          </select>
                          <input type="text" className="input" defaultValue={`010-2322-2222`} />
                        </div>
                      </td>
                      <th>시수 / 등급</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <div className="check">
                            <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                            <label htmlFor="chk01">특별시수</label>
                          </div>
                          <input type="text" className="input" defaultValue={`44,000`} />
                          <input type="text" className="input" defaultValue={`***`} />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>이메일</th>
                      <td>
                        <input type="text" className="input" />
                      </td>
                      <th>시수 구성</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <span className="txt">장기수수료</span>
                          <input type="text" className="input ws" defaultValue={`5,000원`} />
                          <span className="txt">+ 지도관리수수료</span>
                          <input type="text" className="input ws" defaultValue={`5,000원`} />
                          <span className="txt">+ 원고료</span>
                          <input type="text" className="input ws" defaultValue={`5,000원`} />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>담임</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <select className="select">
                            <option value="담임 교사 선택">담임 교사 선택</option>
                          </select>
                        </div>
                      </td>
                      <th>학력 / 전공</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="text" className="input" defaultValue={`한국방송통신대`} />
                          <input type="text" className="input" defaultValue={`미디어영상학과`} />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>계약일</th>
                      <td>
                        <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      </td>
                      <th>논술등급</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <select className="select">
                            <option value="C등급">C등급</option>
                          </select>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>보험가입일 / 유지일</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                          <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                        </div>
                      </td>
                      <th>계좌 정보</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <select className="select wm">
                            <option value="하나은행">하나은행</option>
                          </select>
                          <input type="text" className="input ws" defaultValue={`홍길동`} />
                          <input type="text" className="input wl" defaultValue={`828282918292`} />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>면접/소개/컨택자</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <select className="select wm">
                            <option value="면접자">면접자</option>
                          </select>
                          <select className="select wm">
                            <option value="소개자">소개자</option>
                          </select>
                          <select className="select wm">
                            <option value="컨택자">컨택자</option>
                          </select>
                        </div>
                      </td>
                      <th rowSpan={2}>경력</th>
                      <td rowSpan={2}>
                        <div className="txt">
                          **에듀에서 영어강사로 3년 근무
                          <br />
                          **에듀에서 영어강사로 3년 근무
                          <br />
                          **에듀에서 영어강사로 3년 근무
                          <br />
                          **에듀에서 영어강사로 3년 근무
                          <br />
                          **에듀에서 영어강사로 3년 근무
                          <br />
                          **에듀에서 영어강사로 3년 근무
                          <br />
                          **에듀에서 영어강사로 3년 근무
                          <br />
                          **에듀에서 영어강사로 3년 근무
                          <br />
                          **에듀에서 영어강사로 3년 근무
                          <br />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>거주지 주소</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="text" className="input wl" placeholder="주소" />
                          <button className="com_btn gray xs">우편번호</button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>상세주소</th>
                      <td>
                        <input type="text" className="input" placeholder="주소" />
                      </td>
                      <th>메모</th>
                      <td>
                        <div className="txt_memo">메모메모메모</div>
                      </td>
                    </tr>
                    <tr>
                      <th>세부 계약 조건</th>
                      <td>
                        <div className="com_input_wrap">
                          <input type="text" className="input" defaultValue={`시수 추가시 수강료 인상`} />
                          <input type="text" className="input" defaultValue={`시수 추가시 수강료 인상`} />
                        </div>
                      </td>
                      <th>교육 수료 목록</th>
                      <td>
                        <div className="txt">
                          <p>
                            <span className="item_txt point">ㆍ2023 교사교육 / 2023,05,16 ~2023, 07, 05 / 수료</span>
                          </p>
                          <p>
                            <span className="item_txt">ㆍ2022 교사교육 교사 교육 / 수료</span>
                          </p>
                          <p>
                            <span className="item_txt">ㆍ2021 교사 대표교사 / 포기</span>
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr className="tr_wish">
                      <th>수업 희망 요일</th>
                      <td>
                        <button className="btn_day active">월</button>
                        <button className="btn_day">화</button>
                        <button className="btn_day">수</button>
                        <button className="btn_day">목</button>
                        <button className="btn_day">금</button>
                        <button className="btn_day">토</button>
                        <button className="btn_day">일</button>
                      </td>
                      <td rowSpan={2} colSpan={2} className="td_notice">
                        ㆍ최소 3개 이상 (1순위1개, 2순위2개)지역을 선택해야 합니다. <br />
                        ㆍ신규 교사는 거주지와 원거리 지역이 기본 선택 되어있습니다. 1년 후 수정 가능합니다. <br />
                        ㆍ거주지 이동시 희망 지역을 변경해야 합니다. <br />
                        ㆍ원거리 : 2순위에서 접하지 않은 지역.
                      </td>
                    </tr>
                    <tr className="tr_wish">
                      <th>수업 희망 지역</th>
                      <td>
                        <span className="com_check_box">
                          <input type="checkbox" name="chk" id="chk010" className="com_chk" />
                          <label htmlFor="chk010">원거리 강의 가능</label>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div className="com_btn_wrap center bottom">
                  <button className="com_btn orange s">수정</button>
                  <button className="com_btn line gray s btn_enter">재입사 </button>
                </div>
              </>
            ) : (
              <></>
            )}
          </section>
        </section>
      </div>
      <PopLeave open={modalLeaveOpen} close={() => setModalLeaveOpen(false)} />
      <PopManageCompany open={modalManageCompany} close={() => setModalManageCompany(false)} />
      <PopManageEmployee open={modalManageEmployee} close={() => setModalManageEmployee(false)} />
      <PopManagePosition open={modalManagePosition} close={() => setModalManagePosition(false)} />
      <PopManageSalary open={modalManageSalary} close={() => setModalManageSalary(false)} />
      <PopManageDepartment open={modalManageDepartment} close={() => setModalManageDepartment(false)} />
    </main>
  );
}

export default EmployeeInfo;
